import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import LegalNoticeContentFromMarkdown from '../components/Legal/LegalNoticeContentFromMarkdown';
import $ from 'jquery';
import { PrinterIcon } from '@heroicons/react/24/solid';

export default function LegalNotice() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/legal-notice',
    title: 'Legal Notice',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'legal-notice.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Legal Notice</title>
        <meta name="description" content="Legal notice and terms of use for DISGENET platform." />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/legal-notice" />
        <meta property="og:title" content="DISGENET: Legal Notice" />
        <meta property="og:description" content="Legal notice and terms of use for DISGENET platform." />
      </Helmet>

      <section>
        <link rel="canonical" href="/legal-notice" />
        <div className="container txt-contenido text-right">
          <button
            className="btn bg-light rounded-circle mr-12"
            onClick={downloadSummary}
            title="Download PDF"
          >
            <PrinterIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="container txt-contenido" id="printer">
          <LegalNoticeContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
